module.exports = __webpack_public_path__ + "img/device-tablet.b90738e2.svg";